import React from 'react';

// TODO: Not working because missing categories in front of the name
// Also: check case sensitivity
import * as Icons from '@mehilainen/design-system-tokens/icons'

export default function Icon({ iconprop, iconColor }) {
  const IconElement = Icons[iconprop];

  if (!IconElement) {
    return <></>;
  }
  else return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      strokeWidth={1}
      width={'32px'}
      aria-hidden="true"
      color={iconColor}
      fill={iconColor}
    >
      {
        IconElement.map((path, index) => {
          return <path
            key={index}
            d={path}
          />
        })
      }
    </svg>
  );
}